import { LocaleString } from '../components/LocaleString';

const components = {
  LocaleString,
};

export function useComponents() {
  return components;
}
